import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { COLORS, FONTS, SPRING } from "./constants";
import { GridBackground } from "../EAKCArchitecture/components/GridBackground";

export const Scene1Title: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const exitOpacity = interpolate(frame, [100, 120], [1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  // Episode badge
  const badgeAppear = spring({ frame, fps, config: SPRING.snappy });

  // Main title
  const titleAppear = spring({ frame: frame - 15, fps, config: SPRING.bouncy });

  // Subtitle
  const subAppear = spring({ frame: frame - 40, fps, config: SPRING.gentle });

  // Pipeline preview icons
  const iconsAppear = spring({ frame: frame - 60, fps, config: SPRING.snappy });

  const pipelineSteps = [
    { icon: "💬", label: "Query" },
    { icon: "🧭", label: "Intent" },
    { icon: "✏️", label: "Rewrite" },
    { icon: "🔎", label: "Retrieve" },
    { icon: "🧹", label: "Quarantine" },
    { icon: "🕸️", label: "Graph" },
    { icon: "🧪", label: "CRAG" },
    { icon: "📊", label: "Rerank" },
    { icon: "🤖", label: "Synthesize" },
    { icon: "🛡️", label: "Ground" },
  ];

  return (
    <AbsoluteFill style={{ opacity: exitOpacity }}>
      <GridBackground opacity={0.1} />

      {/* Episode badge */}
      <div
        style={{
          position: "absolute",
          top: 260,
          left: "50%",
          transform: `translate(-50%, 0) scale(${interpolate(badgeAppear, [0, 1], [0.5, 1])})`,
          opacity: interpolate(badgeAppear, [0, 1], [0, 1]),
          padding: "8px 24px",
          borderRadius: 20,
          background: `${COLORS.accentPurple}20`,
          border: `1px solid ${COLORS.accentPurple}50`,
          fontFamily: FONTS.mono,
          fontSize: 16,
          color: COLORS.accentPurple,
          letterSpacing: 2,
          textTransform: "uppercase",
        }}
      >
        Episode 2
      </div>

      {/* Main title */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: `translate(-50%, -70%) scale(${interpolate(titleAppear, [0, 1], [0.7, 1])})`,
          opacity: interpolate(titleAppear, [0, 1], [0, 1]),
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontSize: 80,
            fontFamily: FONTS.heading,
            fontWeight: 800,
            color: COLORS.textPrimary,
            letterSpacing: -2,
          }}
        >
          RAG Pipeline{" "}
          <span
            style={{
              background: `linear-gradient(135deg, ${COLORS.accentBlue}, ${COLORS.accentPurple})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Deep Dive
          </span>
        </div>
      </div>

      {/* Subtitle */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: `translate(-50%, 30px)`,
          opacity: interpolate(subAppear, [0, 1], [0, 1]),
          fontSize: 22,
          fontFamily: FONTS.body,
          color: COLORS.textSecondary,
          textAlign: "center",
          maxWidth: 700,
          lineHeight: 1.5,
        }}
      >
        From user query to grounded, cited answer — 18 real stages, end to end
      </div>

      {/* Pipeline preview — horizontal icons */}
      <div
        style={{
          position: "absolute",
          bottom: 180,
          left: "50%",
          transform: "translate(-50%, 0)",
          display: "flex",
          gap: 24,
          opacity: interpolate(iconsAppear, [0, 1], [0, 1]),
        }}
      >
        {pipelineSteps.map((step, i) => {
          const stepAppear = spring({
            frame: frame - 62 - i * 4,
            fps,
            config: SPRING.snappy,
          });

          return (
            <React.Fragment key={i}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                  opacity: interpolate(stepAppear, [0, 1], [0, 1]),
                  transform: `translateY(${interpolate(stepAppear, [0, 1], [15, 0])}px)`,
                }}
              >
                <div
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: 12,
                    background: COLORS.bgCard,
                    border: `1px solid ${COLORS.borderLight}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 24,
                  }}
                >
                  {step.icon}
                </div>
                <span
                  style={{
                    fontFamily: FONTS.mono,
                    fontSize: 11,
                    color: COLORS.textMuted,
                  }}
                >
                  {step.label}
                </span>
              </div>
              {i < pipelineSteps.length - 1 && (
                <div
                  style={{
                    alignSelf: "center",
                    marginBottom: 20,
                    color: COLORS.textMuted,
                    fontSize: 16,
                    opacity: interpolate(stepAppear, [0, 1], [0, 0.5]),
                  }}
                >
                  →
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
